import { createBrowserHistory } from 'history';
import navigationBlocker from './navigationBlocker';

const getConfirmation = (messageOrUID, callback) => {
    if (!navigationBlocker.notify(messageOrUID, callback)) {
        callback(
            true
            // window.confirm(messageOrUID)
        );
    }
};

const history = createBrowserHistory({ getUserConfirmation: getConfirmation });

export default history;
